// extracted by mini-css-extract-plugin
export var resizer = "_bd-0";